import React, { useRef, useEffect, useState } from "react";
import { ListGroup, Spinner } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import CustomPagination from "../common/CustomPagination";

function Notifications({ notifications, loading }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <>
      <div className="nb-wrap" ref={wrapRef}>

        <button className="nb-btn me-3" onClick={() => setOpen((o) => !o)}>
          <FaBell size={25} />
        </button>

        {open && (
          <div className="nb-dropdown">

            <div className="nb-header">
              <p className="nb-header-title">Notifications</p>
            </div>

            <div className="nb-scroll">
              {loading ? (
                <div className="d-flex align-items-center justify-content-center gap-2 py-4">
                  <Spinner animation="border" variant="primary" size="sm" />
                  <span className="text-secondary" style={{ fontSize: 13 }}>Loading...</span>
                </div>
              ) : notifications.length === 0 ? (
                <div className="d-flex align-items-center justify-content-center py-4">
                  <span className="text-secondary" style={{ fontSize: 13 }}>No notifications yet.</span>
                </div>
              ) : (
                <ListGroup variant="flush">
                  {notifications.map((n) => (
                    <ListGroup.Item key={n?._id} className="nb-item">
                      <div className="nb-body">
                        <div className="nb-row">
                          <p className="nb-title">{n?.title}</p>
                          <span className="nb-time">
                            {moment(n?.createdAt).local().format("MMM DD, hh:mm A")}
                          </span>
                        </div>
                        <p className="nb-desc">{n?.message}</p>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </div>

          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(Notifications);